export const SET_API_KEY = 'SET_API_KEY';
export const setApiKey = (key) => ({
    type: SET_API_KEY,
    payload: key,
});
